import IntlMessages from "../../layout/components/lang/IntlMessages";
import { FolderOutlined, HomeOutlined, MessageOutlined, NotificationOutlined } from "@ant-design/icons";

const pages = [
  {
    id: "home",
    title: <IntlMessages id="sidebar-pages-home" />,
    icon: <HomeOutlined size={20} className="icon-menu"/>,
    navLink: "/",
  },
  {
    id: "contacts",
    title: <IntlMessages id="sidebar-pages-contacts" />,
    icon: <FolderOutlined size={20} className="icon-menu"/>,
    navLink: "/contacts",
  },
  {
    id: "conversations",
    title: <IntlMessages id="sidebar-pages-conversations" />,
    icon: <MessageOutlined size={20} className="icon-menu"/>,
    navLink: "/conversations",
  },
  {
    id: "notifications",
    title: <IntlMessages id="sidebar-pages-notifications" />,
    icon: <NotificationOutlined size={20} className="icon-menu"/>,
    navLink: "/notifications",
  },
];

export default pages;
